<template>
  <div v-if="match !== undefined && match != null" class="a-vs-b--statistics-wrap__head-to-head">
    <statistics-oponnents
      :awayTeam="match.AwayTeam"
      :awayTeamLogo="match.AwayTeamLogo"
      :awayTeamShort="match.AwayTeamShort"
      :homeTeam="match.HomeTeam"
      :homeTeamLogo="match.HomeTeamLogo"
      :homeTeamShort="match.HomeTeamShort"
      :componentTitle="componentTitle"
      :componentSubtitle="componentSubtitle"
    />
    <div class="a-vs-b-card-content">
      <div class="a-vs-c--head-to-head">
        <!-- Single head-to-head statistic -->
        <div v-for="n in currentMatch.HomeTeamGoals.length" :key="n"   class="a-vs-c--single-result">
          <single-statistic
            :homeGoals="currentMatch.HomeTeamGoals[n - 1]"
            :guestGoals="currentMatch.AwayTeamGoals[n - 1]"
            :homePercentage="HomeHTHPercentage[n - 1]"
            :awayPercentage="AwayHTHPercentage[n - 1]"
          />
        </div>
      </div>
      <bottom-summary :currentMatch="currentMatch" :match="match" />
     </div>
  </div>
</template>

<script>
import HTHSingleStatistic from '@/components/soccer/statistics/HTHSingleStatistic.vue'
import BottomSummary from '@/components/soccer/statistics/BottomSummary.vue'

export default {
  components: {
    'single-statistic': HTHSingleStatistic,
    'bottom-summary': BottomSummary
  },
  props: {
    componentTitle: {
      type: String
    },
    componentSubtitle: {
      type: String
    },
    eventData: {
      type: Object,
      required: false
    }
  },
  data () {
    return {
      HomeHTHPercentage: [],
      AwayHTHPercentage: []
    }
  },
  methods: {
    checkIfNull: function (dataPassed) {
      if (dataPassed === null) {
        dataPassed = -1
      }
    },
    percentageGoalsHTH: function () {
      this.AwayHTHPercentage = []
      this.HomeHTHPercentage = []
      this.eventData.Matches[0].Stats.HeadToHead.HomeTeamGoals.map((currentElement, index) => {
        if (this.eventData.Matches[0].Stats.HeadToHead.HomeTeamGoals[index] === 1) {
          this.HomeHTHPercentage.push('40%')
        } else if (this.eventData.Matches[0].Stats.HeadToHead.HomeTeamGoals[index] < 1) {
          this.HomeHTHPercentage.push('0%')
        } else if (this.eventData.Matches[0].Stats.HeadToHead.HomeTeamGoals[index] > 1) {
          let numberP = 40 + (this.eventData.Matches[0].Stats.HeadToHead.HomeTeamGoals[index] - 1) * 20
          if (numberP > 100) numberP = 100
          this.HomeHTHPercentage.push(numberP.toString() + '%')
        }
      })
      this.eventData.Matches[0].Stats.HeadToHead.AwayTeamGoals.map((currentElement, index) => {
        if (this.eventData.Matches[0].Stats.HeadToHead.AwayTeamGoals[index] === 1) {
          this.AwayHTHPercentage.push('40%')
        } else if (this.eventData.Matches[0].Stats.HeadToHead.AwayTeamGoals[index] < 1) {
          this.AwayHTHPercentage.push('0%')
        } else if (this.eventData.Matches[0].Stats.HeadToHead.AwayTeamGoals[index] > 1) {
          let numberP = 40 + (this.eventData.Matches[0].Stats.HeadToHead.AwayTeamGoals[index] - 1) * 20
          if (numberP > 100) numberP = 100
          this.AwayHTHPercentage.push(numberP.toString() + '%')
        }
      })
    }
  },
  computed: {
    match: function () {
      if (this.eventData != null) {
        return this.eventData.Matches[0]
      } else {
        return null
      }
    },
    currentMatch: function () {
      if (this.eventData != null) {
        this.eventData.Matches[0].Stats.HeadToHead.HomeTeamGoals.map(this.checkIfNull)
        this.eventData.Matches[0].Stats.HeadToHead.AwayTeamGoals.map(this.checkIfNull)
        this.percentageGoalsHTH()
        return this.eventData.Matches[0].Stats.HeadToHead
      } else {
        return null
      }
    }
  }
}
</script>
